export default {
    search: {
        nav: {
            subject: "搜索结果"
        }
    }
}
